import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Row, Col, Button, FormGroup, Tabs, Tab, FormControl, Table, Modal, Label, OverlayTrigger, Tooltip, Glyphicon, Dropdown} from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MultiSelect from 'react-select';
import moment from 'moment';

import UsersService from "../../services/users-service";
import FormsService from "../../services/forms-service";
import ActivityLogsService from "../../services/activity-service";
import EventWidget from "../../components/widgets/event-widget";
import {ToastContainer, ToastStore} from 'react-toasts';
import './style.css';
import _ from 'underscore';

class ActivityLog extends Component {

    tableData = {
        columns: [
            {
                label: 'Title',
                field: 'title',
                sort: 'asc',
                width: 300
            },
            {
                label: 'Facility',
                field: 'facility',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Date',
                field: 'date',
                sort: 'asc',
                width: 100
            },
            {
                label: 'Time',
                field: 'time',
                sort: 'asc',
                width: 100
            },
        ],
        rows: []
    }

    constructor(props, context) {
        super(props, context);

        const date = new Date();
        const credentials =  UsersService.sharedInstance.getStoredCredentials().loginResponse;

        this.state = {
            show: false,
            data: this.tableData,
            token: credentials.token_data.token,
            auth_username: credentials.data[0].User_ID,
            license: credentials.data[0].User_License,
            sub_user_id: credentials.data[0].recno,
            showInfoModal: false,
            activityToDisplay: null,
            facility_modal: false,
            facilities: [],
            facility: [],
            facility_filter: []
        }

        this.start_date = moment().format('YYYY-MM-DD');
        this.end_date =  moment().format('YYYY-MM-DD');
        this.options = {
            onRowClick: (row) => this.openModal(row),
            hideSizePerPage: true,
            // defaultSortName: 'title',  // default sort column name
            // defaultSortOrder: 'desc'  // default sort order
        }

        Date.prototype.formattedTime = function(){
            var h = this.getHours();
            var m = this.getMinutes();
            var ampm = h<12 && m <= 59 ? "AM" : "PM";
            h = h>12 ? h-12 : (h == 0 ? 12 : h);
            m = m<10 ? ('0'+m) : m;

            return h+':'+m+' '+ampm;
        }
    }

    componentWillMount(){
        this.fetchActivityLogsWithDate();
        this.fetchForms();
    }

    componentDidMount(){
        this.getFacilities();
    }

    render() {
        return (
                <div>
                    <Row className="widget-top-container">
                      <Col md={5} style={{backgroundColor: "white"}}>
                        <EventWidget events={this.props.events}/>
                      </Col>
                    </Row>
                    <Row className="main-settings-content">
                        <Col>
                            <div className="settings-header">
                                <h2 className="header-title">Activity Log</h2>
                            </div>
                            <div className="content-container">
                                {this.renderFiltersSection()}
                                {this.renderActivityLogs()}
                            </div>
                        </Col>
                    </Row>
                    {this.renderPreviewModal()}
                    {this.renderFilterFacilityModal()}
                    <ToastContainer store={ToastStore} position={ToastContainer.POSITION.TOP_RIGHT}/>
                </div>
            )
    }

    renderFiltersSection(){
        return(
            <div className="filters-section">
                <Row>
                    <Col md={9}>
                        <h3 className="green-title left-title">Filters</h3>
                    </Col>
                    <Col md={3}>
                        <Button type='button' className='green-btn pull-right' onClick={this.onClearFilter}>Clear Filters</Button>
                    </Col>
                </Row>

                <div className="date-input-div">
                    <div className="date-div">
                        <FormGroup>
                            <Label className="label-left">Start Date Range</Label>
                            <FormControl size="sm" value={this.start_date} type='date' onChange={(e)=>this.handleStartDateChange(e)}/>
                        </FormGroup>
                    </div>
                    <div className="date-div">
                        <FormGroup>
                            <Label className="label-left">End Date Range</Label>
                            <FormControl size="sm" value={this.end_date} type='date' onChange={(e)=>this.handleEndDateChange(e)}/>
                        </FormGroup>
                    </div>
                </div>
            </div>
        )
    }

    renderActivityLogs(){
        let {rows} = this.tableData;
        const {facility_filter} = this.state;

        if(facility_filter.length){
            rows = this.filterDataFacility(rows);
        }

        return(
            <div className="activity-logs-div">
                <BootstrapTable width="100%" data={rows} hover={true} keyField="id" search={true} pagination options={this.options} trClassName={"usersRow"}>
                    <TableHeaderColumn dataField='title' width="65%" dataSort>Title</TableHeaderColumn>
                    <TableHeaderColumn dataField='facility' width="15%" dataSort>
                        <OverlayTrigger placement='top' overlay={<Tooltip id='facility-filter-column'>Filter by Facility</Tooltip>}>
                            <Glyphicon glyph='filter' style={{cursor:'pointer'}} onClick={this.onShowFacilityModal} />
                        </OverlayTrigger>
                        Facility
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField='date' width="10%" dataSort>Date</TableHeaderColumn>
                    <TableHeaderColumn dataField='time' width="10%" dataSort>Time</TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

    filterDataFacility = (data) =>{
        const {facility_filter} = this.state;

        return data.filter(row => {
            if(facility_filter.indexOf(row.facility) >= 0){
                return row;
            }
        });
    }

    getFacilities = () =>{
        ActivityLogsService.sharedInstance.getFacilitiesByUserLicense(response => {
            if(response.success){
                const {data} = response;

                this.setState({ facilities:data });
            }else{
                alert(response.message);
            }
        });
    }

    onClearFilter = () =>{
        const that = this;
        const date = moment().format('YYYY-MM-DD');

        this.start_date = date;
        this.end_date = date;

        this.setState({
            facility_filter:[],
            facility:[]
        },() => {
            that.fetchActivityLogsWithDate();
        });
    }

    onShowFacilityModal = () =>{
        this.setState({facility_modal:true});
    }

    onHideFacilityModal = () =>{
        this.setState({facility_modal:false});
    }

    onFacilitySelect = (selected) =>{
        this.setState({facility:selected});
    }

    onFilterFacility = () =>{
        const {facility} = this.state;
        const filter = facility.map(value => {
            return value.value;
        });

        this.setState({facility_filter:filter});
    }

    renderFilterFacilityModal = () =>{
        const {facility,facility_modal,facilities} = this.state;
        let options = [];
        let hasFacilities = facilities ? true : false;
        if(hasFacilities){
            options = facilities.map(facility => {
                return {
                    value:facility.facility_name,
                    label:facility.facility_name
                }
            });
        }
        return (
            <Modal show={facility_modal} onHide={this.onHideFacilityModal}>
                <Modal.Header>
                    <OverlayTrigger overlay={<Tooltip id='close-facility'>Close</Tooltip>}>
                        <Glyphicon
                            glyph='remove'
                            className='pull-right'
                            style={{cursor:'pointer'}}
                            onClick={this.onHideFacilityModal}
                        />
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <MultiSelect
                        value={facility}
                        onChange={this.onFacilitySelect}
                        options={options}
                        isMulti
                    />
                    <div style={{textAlign:'right',padding:10}}>
                        <Button type='button' className='gray-btn btn' onClick={this.onHideFacilityModal}>Cancel</Button> <span></span>
                        <Button type='button' className='green-btn btn' onClick={this.onFilterFacility}>Filter</Button>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }

    renderPreviewModal(){
        return(
            <Modal show={this.state.showInfoModal}>
                <Modal.Header>
                    <b style={{fontSize: 20}}>

                    <OverlayTrigger
                        placement="top"
                        delay={200}
                        overlay={
                                <Tooltip id="overlay-example"> Close </Tooltip>
                        }>
                        <Glyphicon
                            glyph="remove"
                            className="pull-right"
                            style={{cursor: "pointer", marginLeft: 10}}
                            onClick={()=>{
                                this.setState({showInfoModal: false});
                            }}
                        />
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        delay={200}
                        overlay={<Tooltip id="overlay-example">
                                    Download this item
                                </Tooltip>}>
                    <Glyphicon glyph="download-alt"
                        className={"pull-right"}
                        onClick={()=>{
                                // this.downloadArchivePDF();
                                }}
                        style={{ cursor: "pointer", marginLeft: 10}}/>
                    </OverlayTrigger>

                    <OverlayTrigger
                        placement="top"
                        delay={200}
                        overlay={
                                <Tooltip id="overlay-example">
                                    Edit this item
                                </Tooltip>
                            }>
                    <Glyphicon glyph="pencil"
                        className={"pull-right"}
                        onClick={()=>{
                                // this.editArchiveItem();
                                this.setState({showInfoModal: false});
                                this.redirect(this.state.activityToDisplay);

                            }}
                        style={{ cursor: "pointer", marginLeft: 10}}/>
                    </OverlayTrigger>

                    </b>
                </Modal.Header>
                <Modal.Body>
                    {/* <div id="canvasWindow"> */}
                        { this.renderIncidentsContent() }
                    {/* </div> */}
                </Modal.Body>
            </Modal>
        )
    }

    renderIncidentsContent(){
        let incident = this.state.activityToDisplay;

        if (incident == null) return;

        let title = incident.type == "Incidents" ? "Incident" : "Forms";

        //var json_data = JSON.parse(incident.individuals_data);

        return(
            <div className="incident-section">
                <h3 className="orange-title">{incident.title}</h3>
                <h3 className="sub-title">{title} Information</h3>
                <hr className="line"/>

                <div className="" style={{margin: 20}}>
                    <h5 className="info-type">Date: <span className="info-data">{incident.date}</span></h5>
                    <h5 className="info-type">Time: <span className="info-data">{incident.time}</span></h5>
                    <h5 className="info-type">Facility: <span className="info-data">{incident.facility}</span></h5>
                </div>

            </div>
        )
    }

    fetchActivityLogs(){

        const params = {
            "license": this.state.license,
            "token": this.state.token,
            "auth_username": this.state.auth_username,
        }


        ActivityLogsService.sharedInstance.fetchActivityLogs(params)
        .then((response)=>{

            this.tableData.rows = [];

            response.map((item)=>{

                var activity_date = new Date(item.date_added);
                var location = "";
                var json_data = JSON.parse(item.json_data);

                if(item.type == "Forms"){
                    location = json_data.form.facility_name;
                }

                if(item.type == "Incidents"){
                    location = json_data.incident.facility_name;
                }

                //location will vary depending on where the log is from if from forms, incident, etc
               if(item.type == "Incidents"){
                    location = json_data.incident.facility_name;
                }


                var item_data = {
                    "id": item.id,
                    "title": item.title,
                    "json_data": json_data,
                    "facility": location,
                    "date": (activity_date.getMonth()+1) + "/" + activity_date.getDate() + "/" + activity_date.getFullYear(),
                    "time": activity_date.formattedTime(),
                }

                this.tableData.rows.push(item_data);
            })

            this.setState({data: this.tableData});
        })


    }

    fetchActivityLogsWithDate(){
        const params = {
            "license": this.state.license,
            "token": this.state.token,
            "auth_username": this.state.auth_username,
            "start_date": this.start_date,
            "end_date": this.end_date != "" ? this.end_date : this.start_date,
        }



        ActivityLogsService.sharedInstance.fetchActivityLogsByDate(params)
        .then((response)=>{

            this.tableData.rows = [];

            response.map((item)=>{

                const activity_date = new Date(item.date_added);

                let location = "";
                const json_data = JSON.parse(item.json_data);

                if(item.type == "Forms"){
                    location = json_data.form.facility_name;
                }

                if(item.type == "Incidents"){
                    location = json_data.incident.facility_name;
                }

                //location will vary depending on where the log is from if from forms, incident, etc
                if(item.type == "Incidents"){
                    location = json_data.incident.facility_name;
                }


                const item_data = {
                    "id": item.id,
                    "title": item.title,
                    "facility": location,
                    "date": (activity_date.getMonth()+1) + "/" + activity_date.getDate() + "/" + activity_date.getFullYear(),
                    "time": activity_date.formattedTime(),
                }

                this.tableData.rows.push(item_data);
            })

            this.setState({data: this.tableData});
        })
    }

    handleStartDateChange(e){
        this.start_date = e.target.value;

        this.performActualFetching();
    }

    handleEndDateChange(e){
        this.end_date = e.target.value;

        if (this.start_date != ''){
            this.fetchActivityLogsWithDate();
        }
    }

    performActualFetching(){
        // Reset if empty filters:
        if (this.start_date == '' && this.end_date == ''){
            // default fetching:
            this.fetchActivityLogs();
        }

        else {
            this.fetchActivityLogsWithDate();
        }
    }

    openModal(row){
        this.setState({showInfoModal: true, activityToDisplay: row});
    }

    redirect(row) {
        try{
            const rowData = row.json_data.submitted_form;
            const guiltyObject = _.find(this.state.formArchives, (form)=>{return form.id === rowData.id});
            if(guiltyObject != null) {
                const newState = {
                  showEditTab: true,
                  guiltyObject: guiltyObject,
                  tabActiveIndex: 3,
                 }
               this.props.pageChange("Forms", null, newState)
            } else {
               ToastStore.warning("Form involved has been deleted or can no longer be found.", 5000);
            }
        }
        catch(e){
             ToastStore.warning("No data found.", 5000);
        }

    }

    fetchForms() {
      const params = {
          "license": this.state.license,
          "token": this.state.token,
          "auth_username": this.state.auth_username,
      }

        FormsService.sharedInstance.getSubmittedCustomFormByLicense(params)
        .then((response)=>{
          this.setState({
            formArchives: response,
          })
        })
        .catch((err)=>{
          console.log("error: ", err);
        });
    }
}

export default ActivityLog;
